import { useState } from "react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const AUTH_BG = "https://customer-assets.emergentagent.com/job_artist-portal-ldc/artifacts/tzd4nnry_ChatGPT%20Image%20Mar%2020%2C%202026%2C%2007_40_40%20PM.png";
const LOGO = "https://customer-assets.emergentagent.com/job_artist-portal-ldc/artifacts/39dze3hq_Text%20Logo%20Gold_noBG_WEBP.webp";

export default function ResetPassword({ token, onDone }) {
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [done, setDone] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (password.length < 8) { setError("Password must be at least 8 characters"); return; }
    if (password !== confirm) { setError("Passwords do not match"); return; }
    setLoading(true);
    setError("");
    try {
      await axios.post(`${API}/auth/reset-password`, { token, password });
      setDone(true);
    } catch (err) {
      setError(err.response?.data?.detail || "Reset failed. Please request a new link.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="auth-page">
      <div className="auth-left" style={{ backgroundImage: `url(${AUTH_BG})` }}>
        <div className="auth-left-overlay" />
        <div className="auth-left-content">
          <img src={LOGO} alt="London Drumstick Co." className="auth-logo-img" />
          <p className="auth-tagline">ARTIST PORTAL</p>
        </div>
      </div>
      <div className="auth-right">
        <div className="auth-form-container">
          <img src={LOGO} alt="London Drumstick Co." className="auth-logo-mobile" />
          {done ? (
            <div data-testid="reset-success">
              <h1 className="auth-title">PASSWORD UPDATED</h1>
              <p className="auth-subtitle">Your password has been reset successfully.</p>
              <button className="btn-primary" onClick={onDone} data-testid="reset-back-to-login">
                GO TO LOGIN
              </button>
            </div>
          ) : (
            <form onSubmit={submit} data-testid="reset-form">
              <h1 className="auth-title">RESET PASSWORD</h1>
              <p className="auth-subtitle">Choose a new password for your account</p>
              {error && <div className="auth-error" data-testid="reset-error">{error}</div>}
              <div className="form-group">
                <label className="form-label">NEW PASSWORD</label>
                <input
                  data-testid="reset-password-input"
                  type="password"
                  className="form-input"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  placeholder="Minimum 8 characters"
                  required
                  minLength={8}
                  autoFocus
                />
              </div>
              <div className="form-group">
                <label className="form-label">CONFIRM PASSWORD</label>
                <input
                  data-testid="reset-confirm-input"
                  type="password"
                  className="form-input"
                  value={confirm}
                  onChange={(e) => setConfirm(e.target.value)}
                  placeholder="Repeat your password"
                  required
                />
              </div>
              <button data-testid="reset-submit-btn" type="submit" className="btn-primary" disabled={loading}>
                {loading ? "UPDATING..." : "UPDATE PASSWORD"}
              </button>
              <button type="button" className="btn-ghost" onClick={onDone}>
                BACK TO LOGIN
              </button>
            </form>
          )}
        </div>
      </div>
    </div>
  );
}
